import React from 'react';

import type { DropdownItem } from '@commons/Dropdown/Simple/types';
import styles from '@commons/Dropdown/dropdown.scss';
import Icon, { ICON_TYPES } from '@commons/Icon';
import IndicatorCheckbox from '@commons/IndicatorCheckbox';
import Cell from '@commons/Table/Cell';
import Row from '@commons/Table/Row';

import stripHtml from '@utils/stripHtml';
import { testName } from '@utils/testUtils';

interface MobileItemProps {
  isMultiValued: boolean;
  item: DropdownItem;
  selected: boolean;
  selectItem: (item: DropdownItem) => void;
}

function MobileItem(props: MobileItemProps) {
  const { selectItem, isMultiValued, item, selected } = props;

  function select() {
    selectItem(item);
  }

  function renderIcon() {
    return <Icon type={ICON_TYPES.CHECKBOX} containerStyles={styles.dropdownIcon} />;
  }

  const renderContent = () => {
    const optionText = stripHtml(item.text);

    return isMultiValued ? (
      <Row>
        <Cell containerStyles={styles.dropdownListItemMultiValuedCheckboxCell}>
          <IndicatorCheckbox isSelected={selected} />
        </Cell>
        <Cell>{optionText}</Cell>
      </Row>
    ) : (
      <>
        <span>{optionText}</span>
        {selected && renderIcon()}
      </>
    );
  };

  return (
    <li
      role="menuitem"
      tabIndex="-1"
      className={styles.dropdownListItem}
      onClick={select}
      {...testName(stripHtml(item.text), 'option')}>
      {renderContent()}
    </li>
  );
}

export default MobileItem;
